import { render, staticRenderFns } from "./AmendmentAttachments.vue?vue&type=template&id=38387ba6&"
import script from "./AmendmentAttachments.vue?vue&type=script&lang=js&"
export * from "./AmendmentAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports